<template>
  <q-page class="flex column page-layout" style="padding: 0">
    <AllGames />
  </q-page>
</template>

<script>
import AllGames from "@/views/games/AllGamesNew";
export default {
  name: "GamesLibrary",
  components: {
    AllGames,
  },
};
</script>
